module.exports = __webpack_public_path__ + "static/media/header2.7030e645.png";